import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TitledCard } from 'Components/';
import { Filter, Main } from 'Containers/';
import { withRouter } from 'react-router';
import { toastType, createToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import {
  getMonthlyClaimFormReport,
  clearReport,
  clearErrors,
} from './state/report/actions';
import { MonthlyClaimFormForm } from './components/MonthlyClaimFormForm';
import { MonthlyClaimFormFieldEnum as Fields } from 'Common/FieldEnum';
import { MONTHLY_CLAIM_FORM_FORM_NAME } from 'Common/FormEnum';

class MonthlyClaimFormContainer extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;

    if (error) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        if (report === 'No Data') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        } else {
          ReportGeneration(report, 'Monthly Claim Form');
        }
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: MONTHLY_CLAIM_FORM_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    this.props.getMonthlyClaimFormReport(formValues);
  };

  render() {
    return (
      <Fragment>
        {this.props.fetching ? <LoadingPage /> : undefined}
        <Filter title={'Monthly Claim Form'} width={5} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <MonthlyClaimFormForm
              initialValues={{
                [Fields.FromDate]: moment().format('MM/YYYY'),
              }}
              onSubmit={this.handleSubmit}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    report,
    loading,
    error,
  } = state.MonthlyClaimFormState.monthlyClaimForm;

  return {
    report,
    loading,
    error,
  };
};

export const MonthlyClaimForm = withRouter(
  connect(
    mapStateToProps,
    { getMonthlyClaimFormReport, clearErrors, clearReport }
  )(MonthlyClaimFormContainer)
);



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/MonthlyClaimForm.js